// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/sectionCards
import {
  section,
  container,
  title,
  coloredShadow,
  whiteColor,
  hexToRgb
} from 'styles/jss/original/base';

import imageStyles from 'styles/jss/nextjs-material-kit-pro/imagesStyles.js';

const styles = {
  section,
  container,
  title: {
    ...title,
    '@media (max-width: 640px)': {
      marginBottom: '0'
    }
  },
  coloredShadow,
  ...imageStyles,
  cardBackground: {
    '@media (max-width: 640px)': {
      marginBottom: '0'
    }
  },
  cardBody: {
    '@media (max-width: 640px)': {
      paddingTop: '10px',
      paddingBottom: '20px',
      minHeight: 'initial'
    }
  },
  cardTitleWhite: {
    '&, & a': {
      ...title,
      marginTop: '.625rem',
      marginBottom: '0',
      minHeight: 'auto',
      color: whiteColor + ' !important'
    }
  },
  cardCategoryWhite: {
    marginTop: '10px',
    color: 'rgba(' + hexToRgb(whiteColor) + ', 0.7)'
  },
  cardDescriptionWhite: {
    color: 'rgba(' + hexToRgb(whiteColor) + ', 0.8)',
    marginTop: '10px',
    marginBottom: '20px'
  }
};

export default styles;
